import { useEffect, useState } from "react";

export default function OrderPaymentModal({
  open,
  loading = false,
  onClose,
  onSubmit,
  tr = (s) => s,
  orderData,
}) {
  const [amount, setAmount] = useState();

  if (!open) return null;

  const handleSubmit = () => {
    const amountNum = Number(amount);
    if (!isFinite(amountNum) || amountNum <= 0) return;
    onSubmit(amountNum);
  };

  return (
    <div
      className="fixed inset-0 z-[1000] flex items-center justify-center"
      role="dialog"
      aria-modal="true"
    >
      <div
        className="absolute inset-0 bg-black/50"
        onClick={() => !loading && onClose()}
      />
      <div className="relative z-[1001] w-[92%] max-w-[420px] rounded-[12px] bg-white p-5 shadow-xl">
        <div className="flex items-center justify-between mb-4">
          <h4 className="text-lg font-semibold text-[#a5141a]">
            {tr("Оплата")}
          </h4>
          <button
            type="button"
            className="text-gray-500 hover:text-gray-700"
            onClick={() => !loading && onClose()}
            aria-label="Close"
          >
            ✕
          </button>
        </div>
        <div className="text-sm text-gray-600 mb-2">
          <p>
            {tr("Сумма по заказам")}: <b>{Number(orderData?.total) || 0}</b> •{" "}
          </p>
          <p>
            {tr("Оплачено")}: <b>{Number(orderData?.paid_amount) || 0}</b> •{" "}
          </p>
          <p>
            {tr("Остаток")}:{" "}
            <b>{Number(orderData?.total - orderData?.paid_amount) || 0}</b>
          </p>
        </div>
        <label className="block text-sm mb-2">{tr("Введите сумму")}</label>

        <input
          type="number"
          inputMode="numeric"
          min="0"
          step="0.01"
          className="w-full border rounded-md px-3 py-2 outline-none focus:ring-2 focus:ring-[#a5141a]"
          placeholder={String(orderData?.total - orderData?.paid_amount)}
          onChange={(e) => setAmount(e.target.value)}
          disabled={loading}
        />

        <div className="mt-5 flex justify-end gap-2">
          <button
            type="button"
            className="px-4 py-2 rounded-md border"
            onClick={onClose}
            disabled={loading}
          >
            {tr("Отмена")}
          </button>
          <button
            type="button"
            className="px-4 py-2 rounded-md bg-[#a5141a] text-white disabled:opacity-60"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? tr("Подождите...") : tr("Оплатить")}
          </button>
        </div>
      </div>
    </div>
  );
}
